import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { testimonials } from "@/data";
import { JSX } from "react/jsx-runtime";
import { InView } from "@/lib/animations/components";
import {
  staggerOrchestrator,
  cardItem,
  // rowItem,
} from "@/lib/animations/variants";

export function TestimonialsSection(): JSX.Element {
  const featured = testimonials.filter((t) => t.featured);
  // const secondary = testimonials.filter((t) => !t.featured);

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <InView className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-semibold mb-4">
            Trusted by Leading Businesses
          </h2>
          <p className="text-lg text-neutral-800 max-w-lg mx-auto">
            Don't just take our word for it. Here's what our clients say about
            working with Rosewood.
          </p>
        </InView>

        <motion.div
          variants={staggerOrchestrator(0.1, 0.05)}
          initial="initial"
          whileInView="animate"
          viewport={{ once: true }}
          className="grid grid-cols-1 md:grid-cols-3 gap-6"
        >
          {featured.map((testimonial) => (
            <motion.div
              key={testimonial.id}
              variants={cardItem}
              className="border rounded-2xl p-7 transition-all relative"
            >
              <Quote
                size={32}
                className="text-[#C9A84C]/30 absolute top-6 right-6"
              />

              <div className="flex gap-1 mb-4">
                {Array.from({ length: testimonial.rating }).map((_, i) => (
                  <Star
                    key={i}
                    size={14}
                    fill="#C9A84C"
                    className="text-gold"
                  />
                ))}
              </div>

              <p className="leading-relaxed mb-6">
                "{testimonial.content}"
              </p>

              <div className="inline-block px-3 py-1 bg-burgundy/8 rounded-full text-sm font-medium text-burgundy mb-5">
                {testimonial.service}
              </div>

              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-burgundy rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-white font-semibold">
                    {testimonial.name
                      .split(" ")
                      .map((n) => n[0])
                      .join("")}
                  </span>
                </div>
                <div>
                  <p className="font-semibold">
                    {testimonial.name}
                  </p>
                  <p className="text-sm text-neutral-800">
                    {testimonial.role}, {testimonial.company}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
